import { AuditTimeline } from '../../components/AuditTimeline';
import { useHistory } from '../../components/use-history';

/** The driver's whole history: field edits, status changes and document attach/replace are all audited against `entityType: 'driver'`. */
export function DriverHistoryTab({ driverId }: { driverId: string }) {
  const state = useHistory('driver', driverId, true);
  return <AuditTimeline state={state} />;
}
